module.exports = __webpack_public_path__ + "img/switch-arrow.6067605e.svg";